// extracted by mini-css-extract-plugin
module.exports = {"paytm":"paytmIntegration_paytm__3abTG","failurePage":"paytmIntegration_failurePage__FuXsN"};